import { Button, Grid, Typography } from "@mui/material";
import React from "react";
import ReadDOM from "react-dom/client";

const Application: React.FC = () => {
    return (
        <Grid container flexDirection={"column"} justifyContent={"center"} alignItems={"center"} flexGrow={1}>
            <Grid sx={{ mb: 4 }}>
                <img src={"/static/img/redesign.svg"} width={400} />
            </Grid>

            <Grid sx={{ mb: 2 }}>
                <Button
                    variant="outlined"
                    size="large"
                    sx={{ width: 400 }}
                    startIcon={<img src="/static/img/microsoft.svg" width={20} />}
                    onClick={() => {
                        window.location.href = "/login/oauth2/";
                    }}
                >
                    Login with Microsoft
                </Button>
            </Grid>

            <Grid>
                <Typography variant={"caption"}>&#169; Copyright of Redesign Group 2025</Typography>
            </Grid>
        </Grid>
    );
};

const root = ReadDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<Application />);
